<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <path
        d="M31.54,9.71,16,25,.48,9.71A1.57,1.57,0,0,1,.12,8a1.63,1.63,0,0,1,2.63-.51L16,20.52l13.26-13a1.6,1.6,0,0,1,2.27,2.24Z"
    />
</svg>
